import * as actionTypes from './linkPanelActionTypes';

const setOverridden = (overridden: AnyFixMe) => ({
  type: actionTypes.OVERRIDE_LINK_PANEL_SECTIONS,
  overridden,
});

export { setOverridden };
